import { Injectable } from '@angular/core';
import { delay, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menuList: any[] = [
    {
      label: 'Dashboard',
      id: 'dashboard',
    },
    {
      label: 'Deposit',
      id: 'deposit',
      children: [
        {
          label: 'Cash Deposit',
          id: 'EDEP',
          children: [
            {
              label: 'ITM Deposit',
              id: 'EDEP1',
            },
          ],
        },
      ],
    },
  ];

  rootLevelNodes: string[] = [];

  constructor() {}

  getChildren(node: any) {
    // adding delay to mock a REST API call
    return of(node.child).pipe();
  }

  isExpandable(node: any): boolean {
    return node.children && node.children.length;
  }
}
